import React from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { Button, Tooltip } from "antd";
import { useSalesReortModel } from "../salesReortModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { onExport } = useSalesReortModel()
    const action =
        <YhAuth resCode={ResourceAuthEnum.STATIST_SALE_EXPORT}>
            <Tooltip placement="topLeft" title={disableExportMsg}>
                <Button
                    disabled={true}
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onExport}
                >导出</Button>
            </Tooltip>
        </YhAuth>
    return (
        <YhBox title={action} style={{ height: 'calc(100vh - 200px)' }}>
            <DataTable />
        </YhBox>
    )
}